import {
  Box,
  Button,
  Text,
  Stack,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  useToast,
  FormControl,
  FormLabel,
  InputGroup,
  InputRightElement,
  IconButton
} from '@chakra-ui/react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import { useEffect, useState } from 'react'
import ApiManual from './ApiManual'
import { updateKeyAndSecret } from '../services/apiService'
import { useRecoilValue } from 'recoil'
import { authState } from '../atoms/auth'
import { useTranslation } from 'react-i18next'

const ApiManager = () => {
  const { t } = useTranslation()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()
  const [apiKey, setApiKey] = useState('')
  const [apiSecret, setApiSecret] = useState('')
  const [isEditing, setIsEditing] = useState(true) // false면 마스킹 모드
  const [showSecret, setShowSecret] = useState(false)
  const auth = useRecoilValue(authState)

  useEffect(() => {
    if (auth.apiKey) setApiKey(auth.apiKey)
    if (auth.apiSecret) setApiSecret(auth.apiSecret)
  }, [auth])

  const handleSave = async () => {
    try {
      const { data: res } = await updateKeyAndSecret({
        key: apiKey,
        secret: apiSecret
      })
      if (res.statusCode === 200) {
        toast({
          title: t('API 관리'),
          description: res.message,
          status: 'success',
          duration: 2000,
          isClosable: true
        })
        setIsEditing(false)
        onClose()
      }
    } catch (err: any) {
      toast({
        title: t('API 관리'),
        description:
          err.response?.data?.message || t('알 수 없는 오류가 발생했습니다.'),
        status: 'error',
        duration: 3000,
        isClosable: true
      })
    }
  }

  return (
    <>
      <Button variant="outline" colorScheme="purple" onClick={onOpen} w="100%">
        {t('API 관리')}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('API 키 관리')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box mb={5}>
              <Text fontSize="sm" color="gray.600" mb={2}>
                {t('API 키 등록이 처음이신가요?')}
              </Text>
              <ApiManual />
            </Box>

            <Stack spacing={4}>
              <FormControl>
                <FormLabel>{t('Key')}</FormLabel>
                <Input
                  placeholder={t('Key') as string}
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>{t('Secret')}</FormLabel>
                <InputGroup>
                  <Input
                    type={showSecret ? 'text' : 'password'}
                    placeholder={t('Secret') as string}
                    value={apiSecret}
                    onChange={(e) => setApiSecret(e.target.value)}
                  />
                  <InputRightElement width="3rem">
                    <IconButton
                      h="1.75rem"
                      size="sm"
                      aria-label={showSecret ? '비밀번호 숨기기' : '비밀번호 보기'}
                      icon={showSecret ? <ViewOffIcon /> : <ViewIcon />}
                      onClick={() => setShowSecret(!showSecret)}
                      variant="ghost"
                    />
                  </InputRightElement>
                </InputGroup>
              </FormControl>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="purple" onClick={handleSave} w="100%">
              {t('저장')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ApiManager
